import {createReducer} from "typesafe-actions";
import {SEARCH_VALUE} from "../actions";

export const search = createReducer("").handleAction(SEARCH_VALUE, (state, action) => action.payload);